/**
 * Created by ferto
 * Marciano Digital Agency
 * www.marciano.com.mx
 * Date: 01/02/2018.
 *
 * index Vue Store
 */
import BaseStore from '@/store/base-store'

let options = {
  states: {
    currentId: null
  },
  getters: {
    currentId (state) {
      return state.currentId
    },
    current (state) {
      return state.items.filter(x => x.id === state.currentId)
    }
  },
  mutations: {
    setCurrent (state, periodId) {
      state.currentId = periodId
    }
  },
  actions: {
    current ({dispatch, commit, getters, rootGetters, state}, periodId) {
      commit('setCurrent', periodId)
      return true
    }
  }
}

export default new BaseStore('periods', options)



// WEBPACK FOOTER //
// ./src/store/periods/index.js